module.exports = __webpack_public_path__ + "img/wallet.933c6285.svg";